import styled from 'styled-components'

const SeparatorLine = styled.div`
  margin-top: ${props => props.theme.separator.lineMarginTop || '8px'};
  flex-grow: 1;
  height: ${props => props.theme.separator.height};
  background: ${props => props.theme.separator.background};
`

export default SeparatorLine
